<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/moje-oplaty' aria-label='Moje opłaty'>
        Moje opłaty
      </a>
    </li>
    @if (loading()) {
      <li>
        Ładowanie...
      </li>
    } @else {
      <li>
        {{ payment()?.service?.name }}
      </li>
    }
  </app-breadcrumbs>
  <section>
    @if (!loading()) {
      <h2>
        {{ payment()?.service?.name }}
      </h2>
      <div class="gov-card">
        <div class="gov-card__header">
          Dane do opłaty
        </div>
        <div class="gov-card__body">
          <div class="row mb-3">
            <div class="col-md-5">
              <div class="mb-md-4">
                <app-label label="Stan konta na dzień:">
                  {{ currentDate | date }}
                </app-label>
              </div>
              <div>
                <app-label label="Razem wszystkie raty:">
                  {{ payment()?.fee | toNumber | currency }}
                </app-label>
              </div>
            </div>
            <div class="col-md-7">
              <div class="mb-md-4">
                <app-label label="Imię i nazwisko:">
                  {{ payerData()?.fullName || '-' }}
                </app-label>
              </div>
              <div>
                <app-label label="Adres:">
                  {{ payerData()?.street || '-' }}, {{ payerData()?.town }}
                </app-label>
              </div>
            </div>
          </div>
        </div>
        <div class="gov-card__footer">
          <div class="row">
            <div class="col-md-12">
              <app-label label="Konto do wpłat:">
                <div class="d-inline-flex align-items-center">
                  @if (payment()?.service?.accountNumber; as accountNumber) {
                    {{ accountNumber }}
                    <button title="Kopiuj numer konta" type="button" class="btn btn-tertiary icon-btn ms-1"
                            [appCopyToClipboard]="accountNumber">
                      <i class='fa fa-copy'></i>
                    </button>
                  } @else {
                    -
                  }
                </div>
              </app-label>
            </div>
            <div class="col-12">
              <app-label label="Identyficator płatnika:">
                @if (payerData()?.identSigid; as identSigId) {
                  {{ identSigId }}
                  <button title="Kopiuj identyficator płatnika" type="button" class="btn btn-tertiary icon-btn ms-1"
                          [appCopyToClipboard]="identSigId">
                    <i class='fa fa-copy'></i>
                  </button>
                }
              </app-label>
            </div>
            <div class="col-md-12 d-flex align-items-center flex-md-wrap">
              <app-label class="mt-1" label="Łącznie do zapłaty <small>(saldo, odsetki, koszty)</small>:">
                {{ componentsForSelect() | totalAmount | currency }}
                <button title="Kopiuj łączną kwotę do zapłaty" type="button" class="btn btn-tertiary icon-btn ms-1"
                        [appCopyToClipboard]="componentsForSelect() | totalAmount | currency">
                  <i class='fa fa-copy'></i>
                </button>
              </app-label>
              <button [disabled]="!(componentsForSelect() | totalAmount)" (click)="goToPayForAll()"
                      type="button" class="btn btn-primary ms-3 pay-for-all">
                <i class="fa fa-credit-card"></i>
                Zapłać wszystko
              </button>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="row mb-2">
        <div class="col-12 d-flex justify-content-end">
          <span class="d-inline-flex align-items-center">
            @if (selectedComponents().length) {
              <span>
                Wybrane&nbsp;raty:&nbsp;<strong>{{ selectedComponents() | totalAmount | currency }}</strong>
              </span>
              <button type="button" class="btn btn-tertiary icon-btn" (click)="selectedComponents.set([])">
                <span class="sr-only">Odznacz wybrane raty</span>
                <i aria-hidden="true" class="fa fa-times-circle"></i>
              </button>
            } @else {
              <app-label label="Brak wybranych rat do zapłaty"></app-label>
            }
            <button (click)="goToPayForSelected()" type="button" class="btn btn-secondary ms-2"
                    [disabled]="!selectedComponents().length">
              Zapłać za wybrane
            </button>
          </span>
        </div>
      </div>
      <table class="data-table table-stripped">
        <caption class="mb-2">Raty do zapłaty <small>Zaznacz
          raty, które chcesz opłacić</small></caption>
        <thead>
        <tr>
          <th>
            <div class='form-group d-flex align-items-center justify-content-center m-0 p-0 mt-2'>
              <div class='custom-checkbox custom-inline'>
                <input
                  [disabled]="!componentsForSelect().length"
                  #allCheck
                  (change)="toggleSelectAll()"
                  [checked]="(componentsForSelect().length === selectedComponents().length) && !!componentsForSelect().length"
                  id="allCheck"
                  type='checkbox'>
                <label for="allCheck">
                  <span class="sr-only">{{ allCheck.checked ? 'Odznacz' : 'Zaznacz' }} wszystkie raty</span>
                </label>
              </div>
            </div>
          </th>
          <th>
            Nazwa
          </th>
          <th>
            Termin płatności
          </th>
          <th>
            Saldo zobowiązania
          </th>
          <th>
            Odsetki
          </th>
          <th>
            Koszty
          </th>
          <th>
            Kwota łącznie
          </th>
          <th style="width: 13rem">
            <span class="sr-only">Akcje</span>
          </th>
        </tr>
        </thead>
        <tbody>
          @for (item of payment()?.components; track $index) {
            <tr>
              <td class="d-table-cell">
                @if (item | itemTotalAmount) {
                  <div class='form-group d-flex align-items-center justify-content-center m-0 p-0 mt-2'>
                    <div class='custom-checkbox custom-inline'>
                      <input
                        (change)="toggleSelect(item)"
                        [checked]="selectedComponents().includes(item)"
                        #input
                        [id]="'checkCol' + $index"
                        type='checkbox'>
                      <label [for]="'checkCol' + $index">
                        <span class="sr-only">{{ input.checked ? 'Odznacz' : 'Zaznacz' }}</span>
                      </label>
                    </div>
                  </div>
                }
              </td>
              <td>
                {{ item.description }}
              </td>
              <td>
                {{ item?.paymentDate }}
              </td>
              <td>
                {{ item?.value | toNumber | currency }}
              </td>
              <td>
                {{ item?.interest | toNumber | currency }}
              </td>
              <td>
                {{ item?.costs | toNumber | currency }}
              </td>
              <td>
                {{ item | itemTotalAmount | currency }}
              </td>
              <td>
                <span class="d-inline-flex align-items-center justify-content-end">
                  @if (item?.idZap; as idZap) {
                    <a aria-label="Szczegóły" [routerLink]="idZap" class="d-flex align-items-center flex-nowrap">
                    <i aria-hidden="true" class="fa fa-history"></i>&nbsp;<span class="mb-1">Szczegóły</span>
                  </a>
                  }
                  @if (item | itemTotalAmount) {
                    <button
                      (click)="goToPay(item)"
                      type="button"
                      class="ms-3 btn btn-tertiary d-flex align-items-center flex-nowrap">
                    <i class="fa fa-credit-card"></i>
                    <span>Zapłać</span>
                  </button>
                  }
                </span>
              </td>
            </tr>
          }
          @if (!payment()?.components?.length) {
            <tr>
              <td colspan="7">
                <app-alert [closable]="false" alertTitle="Uwaga!">
                  Brak danych wo wyświetlenia
                </app-alert>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <br>
      <app-alert [closable]="false">
        <strong>Uwaga!</strong> Ujemna kwota salda zobowiązania oznacza nadpłatę. Odsetki wyliczono na dzień:
        <strong>{{ currentDate | date }}</strong>
      </app-alert>
    } @else {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    }
  </section>
</app-content>
